@switch (columnName) {
  @case ('statusCompetenceUser') {
    @if (element.statusType === competenceStatusEnum.Red) {
      <mat-icon class="red">circle</mat-icon>
    }
    @if (element.statusType === competenceStatusEnum.Yellow) {
      <mat-icon class="yellow">circle</mat-icon>
    }
    @if (element.statusType === competenceStatusEnum.Orange) {
      <mat-icon class="orange">circle</mat-icon>
    }
    @if (element.statusType === competenceStatusEnum.Green) {
      <mat-icon class="green">circle</mat-icon>
    }
    @if (element.statusType === competenceStatusEnum.White) {
      <mat-icon class="white">circle</mat-icon>
    }
  }
  @case ('hasAttachments') {
    @if (element.hasAttachments) {
      <mat-icon [attr.aria-label]="'hasAttachments' | translate">attach_file</mat-icon>
    }
  }
  @case ('actionCompetenceUser') {
    <div class="competence-user-action-cell">
      @if (element.formId && element.isRegistrationCompleted) {
        <div (click)="routeToCustomForm(element.userCompetenceId, element.formId)">
          <mat-icon>assignment</mat-icon>
        </div>
      } @else {
        @if (element.isExpiring) {
          <app-ui-button
            buttonType="icon-button"
            icon="calendar_month"
            (click)="routeToCompetenceAction()"
            [privilege]="competenceActionPrivilege"
          ></app-ui-button>
        } @else {
          <mat-icon>done</mat-icon>
        }
      }
    </div>
  }
  @case ('competenceCode') {
    <div (click)="routeTo()">{{ element.competenceCode }} {{ element.code }}</div>
  }
  @case ('competenceName') {
    <div (click)="routeTo()">
      {{ element.name }} {{ element.competenceName }}
      <app-equivalent-competences-tooltip
        [competence]="element"
      ></app-equivalent-competences-tooltip>
    </div>
  }
  @case ('requirementType') {
    <div (click)="routeTo()">
      @if (element.requirementType === userCompetenceRequirementType.mandatory) {
        <div>
          {{ 'mandatory' | translate | uppercase }}
        </div>
      }
      @if (element.requirementType === userCompetenceRequirementType.optional) {
        <div>
          {{ 'optional' | translate | uppercase }}
        </div>
      }
      @if (element.requirementType === userCompetenceRequirementType.preferred) {
        <div>
          {{ 'preferred' | translate | uppercase }}
        </div>
      }
      @if (element.requirementType === userCompetenceRequirementType.notRequired) {
        <div>
          {{ 'notRequired' | translate | uppercase }}
        </div>
      }
    </div>
  }
  @case ('expiry') {
    <div (click)="routeTo()">
      @if (element.expiresAt) {
        <div>
          {{ element.expiresAt | date }}
        </div>
      } @else {
        <div>-</div>
      }
    </div>
  }
  @case ('daysUntilExpired') {
    <div (click)="routeTo()">
      @if (element.daysUntilExpired) {
        <div class="center">
          {{ element.daysUntilExpired }}
        </div>
      } @else {
        <div>-</div>
      }
    </div>
  }
  @case ('selfAssignable') {
    <mat-icon class="material-icons-round">
      {{ element.selfAssignable ? 'check' : 'close' }}
    </mat-icon>
  }
  @case ('registrationComplete') {
    <div (click)="routeTo()">
      @if (element.isRegistrationCompleted) {
        <div class="center">
          {{ 'yes' | translate }}
        </div>
      }
      @if (!element.isRegistrationCompleted) {
        <div class="center">
          {{ 'no' | translate }}
        </div>
      }
    </div>
  }
}
